/// <reference lib="dom" />
/** JSON.parse worker 客户端：单例 Worker + 请求 id 映射。
 *  Worker 不可用或解析失败时回退主线程 JSON.parse（保证请求不因 worker 故障失败）。
 */
let worker: Worker | null = null;
let seq = 0;
const pending = new Map<
  number,
  { resolve: (v: unknown) => void; reject: (e: Error) => void }
>();

function ensureWorker(): Worker | null {
  if (worker) return worker;
  if (typeof Worker === "undefined") return null;
  try {
    worker = new Worker(new URL("./json-parse.worker.ts", import.meta.url), {
      type: "module",
    });
    worker.onmessage = (e: MessageEvent<{ id: number; data?: unknown; error?: string }>) => {
      const entry = pending.get(e.data.id);
      if (!entry) return;
      pending.delete(e.data.id);
      if (e.data.error !== undefined) entry.reject(new Error(e.data.error));
      else entry.resolve(e.data.data);
    };
    worker.onerror = () => {
      // worker 崩溃：拒绝所有在途请求（调用方 fallback 主线程），并重置实例
      for (const [, entry] of pending) entry.reject(new Error("json-parse worker crashed"));
      pending.clear();
      worker = null;
    };
  } catch {
    worker = null;
  }
  return worker;
}

export function parseJsonOffThread<T>(text: string): Promise<T> {
  const w = ensureWorker();
  if (!w) return Promise.resolve(JSON.parse(text) as T);
  const id = ++seq;
  return new Promise<T>((resolve, reject) => {
    pending.set(id, { resolve: resolve as (v: unknown) => void, reject });
    w.postMessage({ id, text });
  }).catch(() => {
    // worker 失败回退主线程解析（请求链路不因 worker 故障失败）
    pending.delete(id);
    return JSON.parse(text) as T;
  });
}
